/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown>, project: NonNullable<unknown>, role: NonNullable<unknown> }} Uno_Confirm_Invite_Member_ProjectInputs */



/**
* | output |
* | --- |
* | "Invite {email} to “{project}” as {role}" |
*
* @param {Uno_Confirm_Invite_Member_ProjectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_confirm_invite_member_project = /** @type {((inputs: Uno_Confirm_Invite_Member_ProjectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Confirm_Invite_Member_ProjectInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.email} zu „${i?.project}“ als ${i?.role} einladen`)
	return /** @type {LocalizedString} */ (`Invite ${i?.email} to “${i?.project}” as ${i?.role}`)
});